import React from "react";
import "./Service_Detail.css";
import Header_Banner from "../../common-components/common_banner/header_banner/Header_Banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Complete_Medical from "../../common-components/common_banner/complete_medical/Complete_Medical";
import Why_Choose_Shore from "../../home/why-choose-shore/Why_Choose_Shore";

const Service_Detail = () => {
  const breadcrumbs = [
    { label: "Home", link: "/about-us", isActive: false },
    { label: "SERVICES", link: "", isActive: true },
  ];
  return (
    <>
      <Header_Banner
        imgSrc={"/assets/images/contact-us/contact-banner.png"}
        title_text="Services"
        breadcrumbs={breadcrumbs}
      />
      <section className="detail_services">
        <div className="container">
          <div className="detail_service_holder">
            <div className="row">
              <div className="col-lg-7">
                <div className="left_div_holder">
                  <div className="detail_service_title_holder">
                    <h2 className="detail_service_title">
                      Physical Exam <br />
                      (Height, Weight, BMI, Vitals)
                    </h2>
                  </div>

                  <div className="detail_service_image_holder">
                    <img
                      src="/assets/images/home/medical_services/image-2.png"
                      alt=""
                      className="detail_service_image"
                    />
                  </div>

                  <div className="detail_service_content_holder">
                    <p className="detail_service_text">
                      The Physical Examination is the first and most essential
                      step in assessing a seafarer’s overall health and fitness.
                      At Shore Clinic, this evaluation is conducted with
                      precision to ensure the candidate meets the physical
                      standards required for safe duty at sea.
                      <br /> <br />
                      What This Includes:
                    </p>
                    <h2 className="detail_service_text_title">
                      1. Height & Weight Measurement
                    </h2>
                    <p className="detail_service_text">
                      Accurate measurement of height and weight helps determine
                      the individual’s basic physical profile. This data is also
                      used to calculate the Body Mass Index (BMI) and assess
                      overall body proportion
                    </p>{" "}
                    <br />
                    <h2 className="detail_service_text_title">
                      2. Body Mass Index (BMI)
                    </h2>
                    <p className="detail_service_text">
                      BMI is calculated to evaluate whether the seafarer falls
                      within a healthy weight range.
                      <br />
                      It helps identify:
                      <br />
                      <br />
                      Underweight <br /> <br /> Healthy <br /> <br /> weight{" "}
                      <br /> <br />
                      Overweight <br /> <br /> Obesity <br /> <br /> Maintaining
                      a healthy BMI is important for endurance, balance, and
                      stamina during ship duties.
                    </p>{" "}
                    <br />
                    <h2 className="detail_service_text_title">
                      3. Vital Signs Check
                    </h2>
                    <p className="detail_service_text">
                      We record all essential vital parameters, including:{" "}
                      <br /> <br /> Blood Pressure – to assess cardiovascular
                      health <br />
                      <br /> Pulse Rate – to understand heart rhythm and fitness{" "}
                      <br />
                      <br />
                      Temperature – to check for infections or underlying
                      illness <br />
                      <br />
                      Respiratory Rate – to ensure normal breathing pattern
                      <br />
                      <br />
                      Vital signs help detect early abnormalities and ensure the
                      candidate is stable enough for further testing.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="right_div_holder">
                  <h4 className="right_div_title">Our Services</h4>

                  <div className="right_div_content">
                    <p className="right_div_text">
                      General & Occupational Health Services
                    </p>
                    <div className="right_icon_holder">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="right_icon"
                      />
                    </div>
                  </div>

                  <div className="right_div_content">
                    <p className="right_div_text">
                      Eye and Colour Vision Tests
                    </p>
                    <div className="right_icon_holder">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="right_icon"
                      />
                    </div>
                  </div>

                  <div className="right_div_content">
                    <p className="right_div_text">
                      ECG, X-ray, Audiometry, Spirometry
                    </p>
                    <div className="right_icon_holder">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="right_icon"
                      />
                    </div>
                  </div>

                  <div className="right_div_content">
                    <p className="right_div_text">
                      2D Echo, Cardiac Stress Test, USG Abdomen
                    </p>
                    <div className="right_icon_holder">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="right_icon"
                      />
                    </div>
                  </div>

                  <div className="right_div_content">
                    <p className="right_div_text">Drug and Alcohol Testing</p>
                    <div className="right_icon_holder">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="right_icon"
                      />
                    </div>
                  </div>

                  <div className="right_div_content">
                    <p className="right_div_text">
                      Mental Health & Psychological Evaluation
                    </p>
                    <div className="right_icon_holder">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="right_icon"
                      />
                    </div>
                  </div>

                  <div className="right_div_content">
                    <p className="right_div_text">Corporate Medical Services</p>
                    <div className="right_icon_holder">
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="right_icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Why_Choose_Shore />
      <Complete_Medical />
    </>
  );
};

export default Service_Detail;
